<template>
  <transition name="modal">
    <div class="modal-mask">
        <div class="modal-container">

  <header class="game-definition-form-header">
    <h1>Register</h1>
    <p><em>Signing up is easy.</em></p>
  </header>
        <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="handleSubmit" class="game-definition-form">
            <div class="form-row">
                <label for="firstName">First Name</label>
                <ValidationProvider v-slot="v" rules="required" immediate><input type="text" v-model="user.firstName"  name="firstName" class="form-control" :class="{ 'is-invalid': submitted && v.errors.includes('firstName') }" />
                <div v-if="submitted && v.errors.includes('firstName')" class="invalid-feedback">{{ v.errors.first('firstName') }}</div>
                </ValidationProvider>
            </div>
            <div class="form-row">
                <label for="lastName">Last Name</label>
                <ValidationProvider v-slot="v" rules="required" immediate><input type="text" v-model="user.lastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && v.errors.includes('lastName') }" />
                <div v-if="submitted && v.errors.includes('lastName')" class="invalid-feedback">{{ v.errors.first('lastName') }}</div>
                </ValidationProvider>
            </div>
            <div class="form-row">
                <label for="username">Username</label>
                <ValidationProvider v-slot="v" rules="required" immediate><input type="text" v-model="user.username"  name="username" class="form-control" :class="{ 'is-invalid': submitted && v.errors.includes('username') }" />
                <div v-if="submitted && v.errors.includes('username')" class="invalid-feedback">{{ v.errors.first('username') }}</div>
                </ValidationProvider>
            </div>
            <div class="form-row">
                <label htmlFor="password">Password</label>
                <ValidationProvider v-slot="v" rules="required" immediate><input type="password" v-model="user.password"  name="password" class="form-control" :class="{ 'is-invalid': submitted && v.errors.includes('password') }" />
                <div v-if="submitted && v.errors.includes('password')" class="invalid-feedback">{{ v.errors.first('password') }}</div>
                </ValidationProvider>
            </div>
            <div class="form-row">
                <button class="btn btn-primary" :disabled="invalid">Register</button>
                <img v-show="status.registering" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                <router-link to="/" class="btn btn-link">Cancel</router-link>
            </div>
        </form>
        </ValidationObserver>
        </div>
    </div>
  </transition>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';
import { mapState, mapActions } from 'vuex'

extend('required', {
  ...required,
  message: 'You got to put something here'
});

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data () {
        return {
            user: {
                firstName: '',
                lastName: '',
                username: '',
                password: ''
            },
            submitted: false
        }
    },
    computed: {
        ...mapState('account', ['status'])
    },
    methods: {
        ...mapActions('account', ['register']),
        handleSubmit() {
            this.submitted = true;
            this.register(this.user);
        }
    }
};
</script>

<style scoped="true">
.modal-body {
    max-height: calc(100vh - 210px);
    overflow-y: auto;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}

/* .modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
 */
.modal-container {
  width: 100%;
  margin: 0px auto;
  background-color: rgba(0,0,0,0);
  border-radius: 2px;
/*   box-shadow: 0 2px 8px rgba(0, 0, 0, .33); */
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  
  display: flex;
  flex-direction: column;
  align-items: center;

    max-height: 100%;
    overflow-y: auto;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


.game-definition-form-header {
  text-align: center;
  background-color: #F6F7F8;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  
  width: 80%;
  margin: 40px 0 4px;
  padding: 50px;
}

.game-definition-form-header h1 {
  font-size: 30px;
  margin-bottom: 20px;
}

.game-definition-form {
  background-color: #F6F7F8;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  
  width: 80%;
  padding: 50px;
  margin: 0 0 40px 0;
}

.form-row {
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
}

.form-row input[type='text'],
.form-row input[type='number'] {
  background-color: #FFFFFF;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  width: 100%;
  padding: 7px;
  font-size: 14px;
}

.form-row label {
  margin-bottom: 15px;
}

.form-row input[type='text']:invalid,
.form-row input[type='number']:invalid {
  border: 1px solid #D55C5F;
  color: #D55C5F;
  box-shadow: none; /* Remove default red glow in Firefox */
}

.legacy-form-row {
  border: none;
  margin-bottom: 40px;
}

.legacy-form-row legend {
  margin-bottom: 15px;
}

.legacy-form-row .radio-label {
  display: block;
  font-size: 14px;
  padding: 0 20px 0 10px;
}

.legacy-form-row input[type='radio'] {
  margin-top: 2px;
}
  
.labeled-radio,
.legacy-form-row .radio-label,
.legacy-form-row input[type='radio'] {
  float: left;
}

.form-row select {
  width: 100%;
  padding: 5px;
  font-size: 14px;            /* This won't work in Chrome or Safari */
  -webkit-appearance: none;   /* This will make it work */
}

.form-row textarea {
  font-family: "Helvetica", "Arial", sans-serif;
  font-size: 14px;

  border: 1px solid #D6D9DC;
  border-radius: 3px;

  min-height: 200px;
  margin-bottom: 10px;
  padding: 7px;
  resize: none;
}

.form-row .instructions {
  color: #999999;
  font-size: 14px;
  margin-bottom: 30px;
}

.form-row .checkbox-label {
  margin-bottom: 0;
}

.form-row button {
  font-size: 16px;
  font-weight: bold;

  color: #FFFFFF;
  background-color: #5995DA;

  border: none;
  border-radius: 3px;

  padding: 10px 40px;
  cursor: pointer;
}

.form-row button:hover {
  background-color: #76AEED;
}

.form-row button:active {
  background-color: #407FC7;
}

@media only screen and (min-width: 700px) {
  .game-definition-form-header,
  .game-definition-form {
    width: 600px;
  }
  .labeled-radio {
    flex-direction: column;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row {
    flex-direction: row;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row input[type='text'],
  .form-row input[type='number'],    /* Add */
  .form-row select,                 /* These */
  .form-row textarea {
    width: 250px;
    height: initial;
  }
  .form-row label {
    text-align: right;
    width: 120px;
    margin-top: 7px;
    padding-right: 20px;
  }

  .legacy-form-row {
    margin-bottom: 10px;
  }
  .legacy-form-row legend {
    width: 120px;
    text-align: right;
    padding-right: 20px;
    font-size: 1rem;
    float: left;
  }

  .form-row .instructions {
    margin-left: 120px;
  }

  .form-row .checkbox-label {
    margin-left: 120px;
    width: auto;
  }
  
  .form-row checkbox {
    padding-left: 120px;
    width: auto;
  }
  
  .form-row button {
    margin-left: 120px;
  }  
}
</style>